import type { OrganizationAssessmentSettings } from '@app/src/types/resourceExplorer'
import { RiskStatus } from '@app/src/types/resourceExplorer'
import { RISK_STATUS_DESC_ORDER } from '@app/src/utils/riskStatusHelpers'

/**
 * Returns the highest priority risk status between headquarter and operation risks.
 * Priority: Extreme > High > Medium > Low > NotApplicable > Deactivated
 */
export function getHighestCountryRiskStatus(
  headquarterStatus: RiskStatus,
  operationStatus: RiskStatus,
): RiskStatus | undefined {
  const statuses = [headquarterStatus, operationStatus].filter(Boolean)
  if (statuses.length === 0) return undefined

  const priorityOrder = [...RISK_STATUS_DESC_ORDER, RiskStatus.NotApplicable, RiskStatus.Deactivated]

  return priorityOrder.find(status => statuses.includes(status))
}

/**
 * Extracts activated assessment template IDs from assessment settings.
 */
export function getActivatedAssessmentTemplateIds(assessmentSettings: OrganizationAssessmentSettings[]): Set<number> {
  const activeAssessmentTemplateIds = assessmentSettings
    .filter(setting => setting.isActivated)
    .map(setting => setting.assessmentTemplate.id)
  return new Set(activeAssessmentTemplateIds)
}

/**
 * Builds detailed name for assessment section (e.g., "Template Name: Section Name").
 */
export function buildAssessmentSectionDetailedName(
  templateName: string | undefined,
  sectionName: string | undefined,
): string | undefined {
  const trimmedTemplate = templateName?.trim()
  const trimmedSection = sectionName?.trim()

  if (trimmedTemplate && trimmedSection) {
    return `${trimmedTemplate}: ${trimmedSection}`
  }
  return trimmedSection || trimmedTemplate
}
